import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Typography, IconButton, Button, Chip, Stack, Box
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export default function NotificationDialog({ open, onClose, notification }) {
  if (!notification) return null;

  const title = notification.rendered_title || notification.template?.title;
  const body = notification.rendered_body || notification.template?.body || notification.message;

  const formatDateSmart = (dateString) => {
    try {
      const date = new Date(dateString);
      const now = new Date();
      const diffMs = now - date;
      const diffMinutes = Math.floor(diffMs / (1000 * 60));
      const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
      const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

      if (diffMinutes < 1) return "now";
      if (diffMinutes < 60) return `${diffMinutes} minutes ago`;
      if (diffHours < 24) return `${diffHours} hours ago`;
      if (diffDays < 7) return `${diffDays} days ago`;
      return date.toLocaleDateString();
    } catch {
      return dateString;
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
          <Typography variant="h6" noWrap>
            {title}
          </Typography>
          {notification?.sent_at && (
            <Typography variant="caption" color="text.secondary">
              {formatDateSmart(notification.sent_at)}
            </Typography>
          )}
        </Box>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        {/* الرسالة الأساسية */}
        <Typography variant="body1" sx={{ mb: 2 }}>
          {body}
        </Typography>

        {/* صورة مرفقة */}
        {notification.image_url && (
          <img
            src={notification.image_url}
            alt="Notification"
            style={{ width: '100%', borderRadius: 8, marginBottom: '1rem' }}
          />
        )}

        {/* تفاصيل إضافية */}
        <Stack spacing={1} sx={{ mb: 2 }}>
          {notification.type && (
            <Chip label={`Type: ${notification.type}`} variant="outlined" />
          )}
          {notification.priority !== undefined && (
            <Chip
              label={`Priority: ${notification.priority}`}
              color={notification.priority > 0 ? "warning" : "default"}
            />
          )}
          {notification.category && (
            <Chip label={`Category: ${notification.category}`} variant="outlined" />
          )}
          {notification.expires_at && (
            <Typography variant="subtitle2">
              Expires At: {new Date(notification.expires_at).toLocaleString()}
            </Typography>
          )}
        </Stack>

        {/* رابط الإجراء */}
        {notification.action_url && (
          <Button
            href={notification.action_url}
            target="_blank"
            rel="noopener noreferrer"
            variant="contained"
            color="primary"
            sx={{ mt: 2 }}
          >
            Open Link
          </Button>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="secondary">Close</Button>
      </DialogActions>
    </Dialog>
  );
}
